import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";

export function pickResource<T>(resources: Record<LanguageEnum, T>, language?: LanguageEnum): T {
  return resources[language ?? LanguageEnum.CS] ?? resources[LanguageEnum.CS];
}
